export default import.meta.ROLLDOWN_FILE_URL_VAm5mFTdOsV9Ev4k13$oxg